interface StoreOfficesMap {
    activeOffice?: MapMarker
    activeMarker?: MapMarker
    hoveredMarker?: MapMarker
    // WCAG 2.4.3: Store trigger element for returning focus when popup closes
    triggerElement?: HTMLElement
}

export const useOfficesMapStore = () =>
    useState<StoreOfficesMap>('offices-map-store', (): StoreOfficesMap => {
        return {}
    })
